// extracted by mini-css-extract-plugin
export default {"content":"NftFilterSection_content__ClZE5","subtitle":"NftFilterSection_subtitle__D9r-n"};